export const capitaliseFirstLetterUtil = (string) => string.charAt(0).toUpperCase()
  + string.slice(1).toLowerCase();
